export default class {
  constructor ({config, quoteCriteria, departure, api} = {}) {
    this.departure = departure
    this.config = config
    this.quoteCriteria = quoteCriteria
    this.api = api
  }

  send (contact, {friend, tab, isFailedBooking} = {}) {
    const request = {
      contactDetails: {
        contact: contact,
        friend: friend,
      },
      sellingCompanyCode: this.departure.sellingCompanyCode,
      tourCode: this.departure.productCode,
      departureCode: this.departure.code,
      priceOptions: this.quoteCriteria.priceOptions(),
      tab: tab,
      isFailedBooking: isFailedBooking,
    }

    return this.api.emailQuote(request)
  }
}
